/**
 *车辆所有人档案相关请求
 */
import request from "@/utils/request";

export interface projectListRequestParams {
    page: number;
    limit: number;
    name: string;
}

export const projectListRequestPath = '/api/v2/project/list';


// 获取数据
export const projectListRequest = (params: projectListRequestParams) => {
    return request.get(projectListRequestPath,{
        params
    })
}
